document.addEventListener("DOMContentLoaded", function () {
  // Tüm accordion başlıklarını seç
  const accordionTriggers = document.querySelectorAll(".accordion__title");

  accordionTriggers.forEach(trigger => {
    trigger.addEventListener("click", function () {
      const container = this.nextElementSibling; // accordion__text-wrapper
      const isOpen = this.getAttribute("aria-expanded") === "true";

      // Toggle aria-expanded
      this.setAttribute("aria-expanded", !isOpen);

      // Hafif animasyonlu açma/kapatma
      if (!isOpen) {
        container.style.maxHeight = container.scrollHeight + "px";
      } else {
        container.style.maxHeight = "0px";
      }
    });
  });

  // Sayfa yüklendiğinde tüm accordion kapalı gelsin
  const allContainers = document.querySelectorAll(".accordion__text-wrapper");
  allContainers.forEach(c => {
    c.style.maxHeight = "0px";
    c.style.overflow = "hidden";
    c.style.transition = "max-height 0.3s ease";
  });
});